import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelEmpty } from '../../../../component/common/designSystem';

/**
 * What the section shows when the request itself failed.
 *
 * Deliberately NOT the same state as "not enough people to report" and not the
 * same as "nobody has started a plan". Those two are true statements about the
 * data; this one means we do not know. Showing zeros when the API is
 * unreachable would be a confident lie about the very thing the page exists to
 * report, and showing the withheld state would claim a privacy protection that
 * never ran.
 */
const LoadFailedPanel = ({ className = '' }) => (
  <div className={className}>
    <Panel title="Couldn't load this section" subtitle="The request did not come back">
      <PanelEmpty>
        Nothing was returned by the server, so no figures are shown — an empty page here would read
        as &ldquo;nobody is using Guided Path&rdquo;, which is not what happened.
        <br />
        <br />
        Refreshing usually fixes it. If it keeps happening, the API may be restarting or your
        session may have expired.
      </PanelEmpty>
    </Panel>
  </div>
);

LoadFailedPanel.propTypes = {
  className: PropTypes.string
};

export default LoadFailedPanel;
